import { type ReactElement } from 'react'
import { type CompanyId, type TeamData } from '@terros/common'
import { Stack, Text } from '@mantine/core'
import { useTranslation, type DashboardAudienceKind, type DashboardAudienceTarget } from '@front/model'
import { AudienceTeamOptions } from './AudienceTeamOptions'
import { AudienceRoleOptions } from './AudienceRoleOptions'
import { AudiencePersonOptions } from './AudiencePersonOptions'

export type AudienceSubKind = Extract<DashboardAudienceKind, 'team' | 'role' | 'person'>

type Props = {
  kind: AudienceSubKind
  companyId: CompanyId | undefined
  teams: TeamData[]
  selectedTarget: DashboardAudienceTarget | undefined
  onSelect: (target: DashboardAudienceTarget) => void
}

const TITLES: Map<AudienceSubKind, string> = new Map([
  ['team', 'Which team?'],
  ['role', 'Which role?'],
  ['person', 'Which person?'],
])

/** The second half of the audience choice, shown inline once a kind needs one. */
export function DashboardAudienceSubList({ kind, companyId, teams, selectedTarget, onSelect }: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Stack gap='xs'>
      <Text fw={600} size='sm'>
        {t(TITLES.get(kind) ?? '')}
      </Text>
      {kind === 'team' && <AudienceTeamOptions selectedTarget={selectedTarget} teams={teams} onSelect={onSelect} />}
      {kind === 'role' && (
        <AudienceRoleOptions companyId={companyId} selectedTarget={selectedTarget} onSelect={onSelect} />
      )}
      {kind === 'person' && <AudiencePersonOptions selectedTarget={selectedTarget} onSelect={onSelect} />}
    </Stack>
  )
}
